// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__kOB-Y","label":"CategoryService_label__2mlAB","location":"CategoryService_location__1ABH8"};